import { Route, createBrowserRouter, createRoutesFromElements, useRouteError } from 'react-router';
import { RoutingErrorHandler } from '@livefree/react-ui';
import { BaseLayout } from '@/components/routing/BaseLayout';
import { ShellLayout } from '@/components/routing/ShellLayout';
import { hostRuntime } from '@/core';
import { Dashboard } from '@/components/Dashboard';

const AuthRouter = hostRuntime.getApp('auth')?.routes;
const TicketingRouter = hostRuntime.getApp('ticketing')?.routes;
const TransactionsRouter = hostRuntime.getApp('transactions')?.routes;
const AccountsRouter = hostRuntime.getApp('accounts')?.routes;
const CellularRouter = hostRuntime.getApp('cellular')?.routes;
const DevicesRouter = hostRuntime.getApp('devices')?.routes;
const NotificationsRouter = hostRuntime.getApp('notifications')?.routes;
const SalesRouter = hostRuntime.getApp('sales')?.routes;
const RemindersRouter = hostRuntime.getApp('reminders')?.routes;
const BillingRouter = hostRuntime.getApp('billing')?.routes;
const ProductsRouter = hostRuntime.getApp('products')?.routes;
const SubscriptionsRouter = hostRuntime.getApp('subscriptions')?.routes;
const CollectionsRouter = hostRuntime.getApp('collections')?.routes;

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<BaseLayout />}
      errorElement={<RoutingErrorHandler useRouteError={useRouteError} />}
    >
      <Route element={<ShellLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="auth/*" element={<AuthRouter />} />
        <Route path="sales/*" element={<SalesRouter />} />
        <Route path="ticketing/*" element={<TicketingRouter />} />
        <Route path="transactions/*" element={<TransactionsRouter />} />
        <Route path="accounts/*" element={<AccountsRouter />} />
        <Route path="cellular/*" element={<CellularRouter />} />
        <Route path="devices/*" element={<DevicesRouter />} />
        <Route path="notifications/*" element={<NotificationsRouter />} />
        <Route path="reminders/*" element={<RemindersRouter />} />
        <Route path="billing/*" element={<BillingRouter />} />
        <Route path="products/*" element={<ProductsRouter />} />
        <Route path="subscriptions/*" element={<SubscriptionsRouter />} />
        <Route path="collections/*" element={<CollectionsRouter />} />
      </Route>
    </Route>,
  ),
  { basename: '/' },
);

export const Router = () => router;
